import { useQuery, useQueryClient } from "react-query"
import { useHistory, useParams, useLocation } from "react-router-dom"
import {
  Button,
  ButtonLoader,
  ConfirmDialog,
  FormattedDate,
  Notification,
  SelectInput,
  TextareaField,
} from "../../components"
import { Loader } from "../../components/Loader"
import { CONFIGURATIONS_OPERATORS } from "../../navigation/constants"
import { StatusPill } from "../../components/BasicTable/StatusPill"
import { CLAIMS_STATUSES } from "../../components/BasicTable/StatusPillDefinitions"
import {
  updateOperatorPwd
} from "../../services/operatorServices"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { isSuperAdminUser } from "../../utils/userUtils"

const ROLE_DISPLAY_NAMES = {
  ROLE_SUPER_ADMIN: 'Super Admin',
  ROLE_WH_ADMIN: 'Administrador de almacén',
  ROLE_OPERATOR: 'Operador',
  ROLE_LAST_MILE_SUPERVISOR: 'Supervisor de última milla',
  ROLE_LAST_MILE_OPERATOR: 'Operador de última milla',
  ROLE_INVENTORY_SUPERVISOR: 'Supervisor de inventario',
  ROLE_REVERSE_LOGISTICS_OPERATOR: 'Operador de logística inversa',
  ROLE_INVENTORY_REVIEWER: 'Revisor de inventario',
  ROLE_CUSTOMER: 'OMS',
  ROLE_WH_ADMIN_OMS_ACCESS: 'Acceso OMS (almacén)',
}

const ROLE_COLORS = {
  ROLE_SUPER_ADMIN: 'bg-yellow-400 text-white',
  ROLE_WH_ADMIN: 'bg-green-400 text-white',
  ROLE_OPERATOR: 'bg-blue-500 text-white',
  ROLE_LAST_MILE_SUPERVISOR: 'bg-purple-400 text-white',
  ROLE_LAST_MILE_OPERATOR: 'bg-purple-300 text-white',
  ROLE_INVENTORY_SUPERVISOR: 'bg-indigo-400 text-white',
  ROLE_REVERSE_LOGISTICS_OPERATOR: 'bg-orange-400 text-white',
  ROLE_INVENTORY_REVIEWER: 'bg-teal-400 text-white',
  ROLE_CUSTOMER: 'bg-gray-400 text-white',
  ROLE_WH_ADMIN_OMS_ACCESS: 'bg-gray-500 text-white',
}

export const OperatorDetailContainer = ({ onClose }) => {
  let { id } = useParams()
  const history = useHistory()
  const location = useLocation()
  const queryClient = useQueryClient()
  const {warehouse_id} = useParams()
  const { i18n } = useTranslation()
  const [showClipboardCopied, setShowClipboardCopied] = useState(false)
  // const { isLoading, isFetching, isError, error, data, refetch } = useQuery(
  //   "claim",
  //   () => fetchClaim(id),
  //   {
  //     // refetchOnWindowFocus: false,
  //   }
  // )

  const [userPassword, setUserPassword] = useState(null)
  // const [selectedSubcategory, setSelectedSubcategory] = useState(null)
  const [resolution, setResolution] = useState(null)
  const [showResetNotification, setShowResetNotification] = useState(false)
  const [showResetErrorNotification, setShowResetErrorNotification] = useState(false)
  const [resetErrorMessage, setResetErrorMessage] = useState("")
  const [loadingSubmitReset, setLoadingSubmitReset] = useState(false)
  const closeTimerRef = useRef(null)

  useEffect(() => {
    return () => clearTimeout(closeTimerRef.current)
  }, [])

  if (!location.state?.user) {
    history.push(CONFIGURATIONS_OPERATORS.replace(':warehouse_id', warehouse_id))
    return null
  }

  // const [showAcceptConfirmDialog, setShowAcceptConfirmDialog] = useState(false)
  // const [showRejectConfirmDialog, setShowRejectConfirmDialog] = useState(false)
  // const [loadingSubmitClaim, setLoadingSubmitClaim] = useState(false)
  // const [accepted, setAccepted] = useState(null)
  // const [acceptedValue, setAcceptedValue] = useState(null)

  // useEffect(() => {
  //   setSelectedCategory(findCategory(data?.category))
  //   setSelectedSubcategory(findSubcategory(data?.subcategory))
  // }, [data])

  // const claimCategories = useMemo(() => {
  //   let categories = [{ id: 0, name: "Ninguna", subcategories: [] }]
  //   categories = categories.concat(
  //     CLAIM_CATEGORIES.map((cat, index) => {
  //       return { ...cat, name: cat.label, id: index + 1 }
  //     })
  //   )
  //   // console.log("categories", categories)
  //   return categories
  // }, [true])

  // const subcategories = useMemo(() => {
  //   if (selectedCategory === null) {
  //     return [{ id: 0, name: "Ninguna" }]
  //   } else if (selectedCategory.id === 0) {
  //     return [{ id: 0, name: "Selecciona categoría" }]
  //   }
  //   let subcategories = [{ id: 0, name: "Ninguna" }]
  //   subcategories = subcategories.concat(
  //     selectedCategory.subcategories.map((subcat, index) => {
  //       return { name: subcat, id: index + 1 }
  //     })
  //   )
  //   // console.log("subcategories", subcategories)
  //   return subcategories
  // }, [selectedCategory])

  // const findCategory = (key) => {
  //   let foundIndex = claimCategories.findIndex((cat) => cat.key === key)
  //   // console.log("claimCategories[foundIndex]", claimCategories[foundIndex])
  //   if (foundIndex === -1) {
  //     foundIndex = 0
  //   }
  //   return claimCategories[foundIndex]
  // }

  // const findSubcategory = (subcategory) => {
  //   // console.log("findSubcategory-subcategories", subcategories)
  //   // console.log("subcategory", subcategory)
  //   let subCatIndex = subcategories.findIndex(
  //     (subcat) => subcat.name === subcategory
  //   )
  //   if (subCatIndex === -1) {
  //     subCatIndex = 0
  //   }
  //   // console.log("subcategories[subCatIndex]", subcategories[subCatIndex])
  //   return subcategories[subCatIndex]
  // }

  // const onChangeCategory = async (val) => {
  //   if (selectedCategory.id != val.id) {
  //     setSelectedCategory(val)
  //     let sentCat = val.key
  //     if (val.id === 0) {
  //       sentCat = null
  //     }
  //     try {
  //       await claimCategory(data.id, { category: sentCat, subcategory: null })
  //       setShowCategoryNotification(true)
  //     } catch (error) {
  //       console.log(error)
  //       window.alert(error)
  //     }
  //   }
  // }

  // const onChangeSubcategory = async (val) => {
  //   if (
  //     selectedSubcategory.id != val.id ||
  //     selectedSubcategory.name != val.name
  //   ) {
  //     setSelectedSubcategory(val)
  //     let sentSubcat = val.name
  //     if (val.id === 0) {
  //       sentSubcat = null
  //     }
  //     try {
  //       await claimCategory(data.id, {
  //         category: selectedCategory.key,
  //         subcategory: sentSubcat,
  //       })
  //       setShowCategoryNotification(true)
  //     } catch (error) {
  //       console.log(error)
  //       window.alert(error)
  //     }
  //   }
  // }

  // const onChangeResolution = (val) => {
  //   setResolution(val.trim())
  // }

  // const onAcceptClaim = async () => {
  //   setLoadingSubmitClaim(true)
  //   try {
  //     await acceptClaim(data.id, resolution, acceptedValue)
  //     queryClient.invalidateQueries('claims_pending_count')
  //     setShowAcceptConfirmDialog(false)
  //     refetch()
  //   } catch (error) {
  //     console.log(error)
  //     window.alert(error)
  //   }
  //   setLoadingSubmitClaim(false)
  // }

  // const onRejectClaim = async () => {
  //   setLoadingSubmitClaim(true)
  //   try {
  //     await rejectClaim(data.id, resolution)
  //     queryClient.invalidateQueries('claims_pending_count')
  //     setShowRejectConfirmDialog(false)
  //     refetch()
  //   } catch (error) {
  //     console.log(error)
  //     window.alert(error)
  //   }
  //   setLoadingSubmitClaim(false)
  // }

  // const onAcceptanceRadioChange = (val) => {
  //   if (val === "accepted") {
  //     setAccepted(true)
  //   } else {
  //     setAccepted(false)
  //   }
  // }

  // const disableSubmit = () => {
  //   if (resolution === null || resolution === "") {
  //     return true
  //   }
  //   if (accepted === null) {
  //     return true
  //   }
  //   if (accepted === true) {
  //     if (acceptedValue === null || acceptedValue === "") {
  //       return true
  //     }
  //   }
  //   return false
  // }
  const generatePwd = (id) => {
    let firstBlockChars = "abcdefghijklmnopqrstuvwxyz";
    let firstBlockPasswordLength = 3;
    let secondBlockChars = "0123456789";
    let secondBlockPasswordLength = 2;
    let thirdBlockChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let thirdBlockPasswordLength = 2;
    let password = "";
    for (let i = 0; i <= firstBlockPasswordLength; i++) {
      let randomNumber = Math.floor(Math.random() * firstBlockChars.length);
      password += firstBlockChars.substring(randomNumber, randomNumber +1);
    }
    password += "@";
    for (let i = 0; i <= secondBlockPasswordLength; i++) {
      let randomNumber = Math.floor(Math.random() * secondBlockChars.length);
      password += secondBlockChars.substring(randomNumber, randomNumber +1);
    }
    for (let i = 0; i <= thirdBlockPasswordLength; i++) {
      let randomNumber = Math.floor(Math.random() * thirdBlockChars.length);
      password += thirdBlockChars.substring(randomNumber, randomNumber +1);
    }
    setUserPassword(password)
  }

  return (
    <>
      <Notification
        show={showClipboardCopied}
        setShow={setShowClipboardCopied}
        type="success"
        title={i18n.t('list_operators.notifications.copied')}
      />
      <Notification
        show={showResetNotification}
        setShow={setShowResetNotification}
        type="success"
        title={i18n.t('list_operators.notifications.password_reset_success')}
      />
      <Notification
        show={showResetErrorNotification}
        setShow={setShowResetErrorNotification}
        type="error"
        title={i18n.t('list_operators.notifications.password_reset_error')}
        description={resetErrorMessage}
      />
      <div className="mt-4">
        {/* User info card */}
        <div className="bg-gray-50 rounded-lg p-5 mb-6">
          <div className="flex items-center">
            <div className="h-12 w-12 rounded-full bg-blue-500 flex items-center justify-center text-white text-lg font-semibold">
              {location.state.user.first_name?.charAt(0)}{location.state.user.last_name?.charAt(0)}
            </div>
            <div className="ml-4 flex-1">
              <div className="flex items-center gap-2">
                <h3 className="text-base font-semibold text-gray-900">
                  {location.state.user.first_name} {location.state.user.last_name}
                </h3>
                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${location.state.user.is_enabled ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                  {location.state.user.is_enabled ? i18n.t('list_operators.detail.status_active') : i18n.t('list_operators.detail.status_disabled')}
                </span>
              </div>
              <p className="text-sm text-gray-500">{location.state.user.email}</p>
            </div>
          </div>
        </div>

        {/* Roles section */}
        <div className="bg-white border border-gray-200 rounded-lg p-5 mb-4">
          <h4 className="text-sm font-semibold text-gray-900 mb-3">{i18n.t('list_operators.detail.roles')}</h4>
          <div className="flex flex-wrap gap-2">
            {(location.state.user.roles || []).map((role) => (
              <span
                key={role}
                className={`inline-flex items-center px-3 py-1 rounded text-xs font-semibold ${ROLE_COLORS[role] || 'bg-gray-200 text-gray-700'}`}
              >
                {ROLE_DISPLAY_NAMES[role] || role}
              </span>
            ))}
          </div>
        </div>

        {/* Warehouses section */}
        <div className="bg-white border border-gray-200 rounded-lg p-5 mb-4">
          <h4 className="text-sm font-semibold text-gray-900 mb-3">{i18n.t('list_operators.detail.warehouses')}</h4>
          {isSuperAdminUser(location.state.user) ? (
            <p className="text-sm text-gray-600">{i18n.t('list_operators.all_warehouses')}</p>
          ) : (location.state.user.warehouse_ids && location.state.user.warehouse_ids.length > 0) ? (
            <div className="flex flex-wrap gap-2">
              {location.state.user.warehouse_ids.map((whId) => (
                <span
                  key={whId}
                  className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700"
                >
                  {location.state.warehouseMap?.[whId] || whId}
                </span>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-400">{i18n.t('list_operators.detail.no_warehouses')}</p>
          )}
        </div>

        {/* Reset password section */}
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <h4 className="text-sm font-semibold text-gray-900 mb-4">{i18n.t('list_operators.reset_password')}</h4>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {i18n.t('list_operators.password')}
              </label>
              <div className="flex items-center gap-3">
                <input
                  type="text"
                  value={userPassword}
                  onChange={(e) => setUserPassword(e.target.value)}
                  placeholder={i18n.t('list_operators.password')}
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => generatePwd()}
                className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-md text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500"
              >
                {i18n.t('list_operators.generate_password')}
              </button>
              <button
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(userPassword)
                  setShowClipboardCopied(true)
                }}
                className="inline-flex items-center px-3 py-1.5 border border-gray-300 rounded-md text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500"
              >
                {i18n.t('list_operators.copy_password')}
              </button>
            </div>
            <div className="pt-2">
              <ButtonLoader
                type="primary"
                className="w-full"
                loading={loadingSubmitReset}
                onClick={async () => {
                  setLoadingSubmitReset(true)
                  try {
                    await updateOperatorPwd(location.state.user.email, userPassword)
                    setShowResetNotification(true)
                    closeTimerRef.current = setTimeout(() => {
                      history.push(CONFIGURATIONS_OPERATORS.replace(':warehouse_id', warehouse_id))
                    }, 1500)
                  } catch (error) {
                    const backendMessage = error?.response?.data?.error || null
                    setResetErrorMessage(backendMessage)
                    setShowResetErrorNotification(true)
                  } finally {
                    setLoadingSubmitReset(false)
                  }
                }}
              >
                {i18n.t('list_operators.reset_password')}
              </ButtonLoader>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
